<template>
  <div class="container-sm">
    <div class="options-list-control-container">
      <div
        class="options-control-list-wrapper"
        v-for="(value, index) in options"
        :key="value.id"
      >
        <button
          class="option"
          @click="handleOptionClick(value)"
          :class="getOptionClassName(value)"
          :disabled="isSolvedQuiz"
        >
          {{index + 1}}. {{ value.content }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import quizOptionsControls from '@/mixins/quizOptionsControls';

export default {
  name: 'quiz-options-list-control',

  mixins: [quizOptionsControls],

  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/styles/components/_typographies';
  @import '../assets/styles/components/_breakpoints';
  @import '../assets/styles/components/_variables';

  .options-list-control-container {
    list-style: none;
    margin: 0;
    overflow: hidden;
    padding: 14px 0px 14px 0px;

    .options-control-list-wrapper {
      margin-bottom: 8px;

      .option {
        display: block;
        padding: 12px 16px;
        background-color: #fff;
        border: 1px solid rgba(0,0,0,.12);
        border-radius: 4px;
        color: #000;
        cursor: pointer;
        line-height: 1.65;
        width: 100%;
        text-align: left;
        font-size: 20px;

        @media (max-width: $tablet-breakpoint) {
          font-size: 16px;
        }

        &:hover {
          border-color: #00c896;
          color: #00c896;
        }

        &:active {
          border-color: #00c896;
          color: #00c896;
        }

        &:focus {
          outline: none;
        }

        &.correct {
          border-color: $correct-option-color;
          color: $correct-option-color;
        }

        &.incorrect {
          border-color: $incorrect-option-color;
          color: $incorrect-option-color;
        }

        &.selected {
          border-color: #00c896;
          color: #00c896;
        }

      }
    }
  }
</style>
